import { ApplicationModeEnum } from "state/ApplicationStateSchema";
import { UsStates } from "state/RootSchema";

type DisqualifiedStates = { [key in ApplicationModeEnum]: UsStates[] };

export const DISQUALIFIED_STATES: DisqualifiedStates = {
    directterm: ["NY"],
    loyalty: ["MA", "MN", "NH", "NM", "NY", "VT", "OR", "WA"],
    giwl: ["NY"],
};
